module.exports = __webpack_public_path__ + "img/relax_gaming.b6a01765.png";